import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class MomentPipe implements PipeTransform {
  transform(value: Date | moment.Moment, formatString: string): string {
    return moment(value).format(formatString);
  }
}
